import React from 'react';
import { Button, Modal, ModalProps } from 'react-bootstrap';

export type OTPModalProps = ModalProps & {
  title?: string;
  message?: string;
  onClickYes?: () => void;
  onClickNo?: () => void;
};

const ModalConfirm = ({
  onHide,
  title,
  message,
  onClickYes,
  onClickNo,
  ...props
}: OTPModalProps) => {
  return (
    <Modal centered onHide={onHide} {...props}>
      <Modal.Body className="modalConfirm d-flex flex-column gap-3 align-items-center justify-content-center px-5 pt-4 pb-2">
        {title && <h3 className="modalConfirm-title ">{title}</h3>}
        {message && <p className="modalConfirm-message">{message}</p>}
        <div className="w-100 d-flex align-items-center justify-content-around gap-5">
          <Button size="lg" onClick={onClickNo}>
            いいえ
          </Button>
          <Button size="lg" variant="danger" onClick={onClickYes}>
            はい
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalConfirm;
